var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: { visible: true, title: _vm.title },
          on: { close: _vm.onFormClose },
        },
        [
          _vm.isFormBusy ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("quick-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isFormBusy,
                expression: "!isFormBusy",
              },
            ],
            attrs: {
              "get-form-url": _vm.getFormUrl,
              "initial-model": _vm.model,
              mode: _vm.mode,
            },
            on: {
              initialized: this.onFormInitialized,
              "initialization-error": this.onFormInitializationError,
              created: _vm.onCreated,
              updated: _vm.onUpdated,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }